import { Routes } from '@angular/router';

export const SETTINGS_ROUTES: Routes = [
	{
		path: '',
		loadComponent: () => import('./settings.component').then((m) => m.SettingsComponent),
		children: [
			{
				path: 'users',
				loadComponent: () => import('./users/user.component').then((m) => m.UserComponent),
			},
			{
				path: 'permissions',
				loadComponent: () => import('./permissions/permission.component').then((m) => m.PermissionComponent),
			},
			{
				path: 'campaigns',
				loadComponent: () => import('./campaigns/campaign-settings.component').then((m) => m.CampaignSettingsComponent),
				data: {
					features: ['settings.campaigns'],
				},
			},
			{
				path: 'genai',
				loadComponent: () => import('./genai/genai.component').then((m) => m.GenaiSettingsComponent),
				data: {
					features: ['settings.genai'],
				},
			},
		],
	},
];
